import type { FaireProductEntity } from "../../entity_types/product";

export const p_6v5gednu4p: FaireProductEntity = {
  token: "p_6v5gednu4p",
  type: "product",
  name: "Ceramic Whisk Stand Holder",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/6d21aba2d31c4001f4c7e268db11681b5eda01c508b9a4918f650a36776f796c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed9c7f060ffc489ba03b62a7412b873a315e78356cda8900f6a033b9b7a12d49.jpeg"
  ],
  priceDollars: 10,
  description: "Rocky's Matcha presents the Ceramic Whisk Stand Holder, a must-have for matcha enthusiasts. Crafted in a classic white ceramic, this holder is not only functional but also adds a touch of elegance to your kitchen. It's designed to maintain the shape of your whisk and prolong its lifespan. Ideal for home use or in our traveling tea houses in Los Angeles, Miami, New York, and Tokyo. Enjoy a perfect cup of matcha with Rocky's Matcha!",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:22.298Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
